import { CATEGORY_ICONS } from "@/lib/meta";

export const CategoryPicker = ({ categories, selected, onSelect }) => (
  <div>
    <p className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-4">Step 1 · Inquiry type</p>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" data-testid="category-grid">
      {categories.map((c, i) => {
        const Icon = CATEGORY_ICONS[c.icon] || CATEGORY_ICONS.MessageSquare;
        const active = selected === c.id;
        return (
          <button
            key={c.id}
            data-testid={`inquiry-category-${c.id}`}
            onClick={() => onSelect(c.id)}
            style={{ animationDelay: `${i * 50}ms` }}
            className={`rise text-left p-5 rounded-2xl border transition-[transform,border-color,background-color,box-shadow] duration-200 hover:-translate-y-1 group ${
              active
                ? "bg-indigo-500/10 border-indigo-500/60 shadow-[0_0_28px_rgba(99,102,241,0.2)]"
                : "bg-[#11131E] border-slate-800/80 hover:border-indigo-500/40 hover:bg-[#141726]"
            }`}
          >
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center mb-4 transition-colors ${active ? "bg-indigo-500 text-white" : "bg-[#1F2338] text-indigo-300 group-hover:bg-indigo-500/20"}`}>
              <Icon className="w-5 h-5" />
            </div>
            <p className={`font-display font-semibold text-sm leading-snug ${active ? "text-slate-50" : "text-slate-200"}`}>{c.label}</p>
            <p className="mt-1.5 text-xs text-slate-400 leading-relaxed">{c.description}</p>
          </button>
        );
      })}
    </div>
  </div>
);
